import { BreakPoints } from '@kanda-libs/ks-design-library';

import Mobile from './Mobile';
import Desktop from './Desktop';
import { Provider } from './Context';

interface ViewComponentProps {
  /**
   * Name of field
   */
  item?: {
    title?: string;
    description?: string;
    quantity?: number;
    price?: {
      amount?: number;
      currency?: string;
    };
    vat_rate?: string;
    vat?: {
      amount?: number;
      currency?: string;
    };
  };
  /**
   * Is loading
   */
  isLoading?: boolean;
  /**
   * Variant
   */
  variant?: 'job-details' | 'customer-job-view' | 'job-summary';
}

const ViewComponent = (props: ViewComponentProps) => (
  <Provider {...props}>
    <BreakPoints mobile={<Mobile />} desktop={<Desktop />} />
  </Provider>
);

ViewComponent.displayName = 'LineItem-view';

ViewComponent.defaultProps = {
  isLoading: undefined,
  item: undefined,
  variant: 'job-details',
};

export default ViewComponent;
